import { inject, Injectable } from '@angular/core';
import { HttpClientWrapper } from './http-client-wrapper.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import {
  CreateUserModel,
  MfaUserProfileModel,
  ProductModel,
  UserProfileModel,
} from '../models/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class UserSessionService {
  private httpWrapper = inject(HttpClientWrapper);

  login(username: string, password: string): Observable<MfaUserProfileModel> {
    const formData = new HttpParams({
      fromObject: { username, password },
    });

    return this.httpWrapper.post('/user/login', formData, {});
  }

  logout(): Observable<any> {
    return this.httpWrapper.get('/user/logout');
  }

  getUser(): Observable<UserProfileModel> {
    return this.httpWrapper.get('/user/profile', {});
  }

  createUser(userData: CreateUserModel, token: string): Observable<any> {
    const formData = new HttpParams({
      fromObject: {
        ...userData,
        token,
      },
    });

    return this.httpWrapper.post('/user/signup', formData, {});
  }

  completePairing(token: string): Observable<any> {
    return this.httpWrapper.post('/token/pairing/complete', {}, { token });
  }

  pairProduct(): Observable<any> {
    return this.httpWrapper.post('/token/pairing-down', {}, {});
  }

  unpairProduct(product: ProductModel): Observable<any> {
    return this.httpWrapper.post(
      '/product/unpair',
      getProductBody(product),
      {},
    );
  }

  getSwitchToken(product: ProductModel): Observable<any> {
    return this.httpWrapper.post('/product/login', getProductBody(product), {});
  }
}

function getProductBody(product: ProductModel) {
  return {
    code: product.code,
    loginUrl: product.loginUrl,
    userid: product.userid,
  };
}
